import {
  CcfAlert,
  CcfAvatar,
  CcfBadge,
  CcfBox,
  CcfButton,
  CcfCopilotSuggestionIcon,
  CcfHeartIcon,
  CcfNeutralSentimentIcon,
  CcfSadSentimentIcon,
  CcfSnackBar,
  CcfTooltip,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-copilot-videocall-card.module.scss';

import { Avatar } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  activeContactSelector,
  updateActiveContact,
} from '../../../../ccf-inbox/ccf-inbox.slice';
import { VoiceContactStatus } from '@nice-ccf/core-sdk';
import {
  getSpaceBtnCounterForCopilotCard,
  setIsSuggestionClicked,
  suggestionsCard,
} from '../../ccf-copilot-chat/+state/ccf-copilot.slice';

/* eslint-disable-next-line */
export interface CcfCopilotVideoCallCardProps {
  suggestionsCardList?: suggestionsCard[];
}

/**
 * CcfCopilot - used to display Copilot card in copilot tab for video call interaction
 * @param props -?-CcfCopilotVideoCallCardProps
 * @example <CcfCopilotVideoCallCard />
 */
export function CcfCopilotVideoCallCard(props: CcfCopilotVideoCallCardProps) {
  const { suggestionsCardList } = props;
  const activeContact = useSelector(activeContactSelector);
  const [showCallTransferedToast, setshowCallTransferedToast] = useState(false);
  const [CallTransferredMessage, setCallTransferredMessage] = useState('');
  const dispatch = useDispatch();

  /**
   * Function to Initiate Call Transfer
   * @param user - Agent
   * @example initiateCallTransfer(user)
   */
  function initiateCallTransfer(user: string) {
    if (activeContact) {
      setTimeout(() => {
        dispatch(
          updateActiveContact({
            id: activeContact?.id || '',
            updates: { contactStatus: VoiceContactStatus.DISCONNECTED },
          })
        );
      }, 1000);
      setCallTransferredMessage(`Call Transferred to ${user}`);
      setshowCallTransferedToast(true);
    }
  }

  /**
   * Used to close the snackbar
   * @param event -React.SyntheticEvent
   * @param reason -string
   * @example - handleClose()
   */
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setshowCallTransferedToast(false);
    setCallTransferredMessage('');
  };

  /**
   * Used to select the suggestion Card
   * @param event -React.SyntheticEvent
   * @param reason -string
   * @example - suggestionCardSelectHandler()
   */
  const suggestionCardSelectHandler = (suggestion: any) => {
    if (suggestion.msgType === 'suggestion' && suggestion?.suggestionLabel) {
      dispatch(setIsSuggestionClicked(true));
    }
  };

  return (
    <>
      {suggestionsCardList &&
        suggestionsCardList?.length > 0 &&
        suggestionsCardList?.map((suggestion: any, index: number) => {
          return Object.keys(suggestion).length > 0 &&
            suggestion.msgType !== 'flow' &&
            suggestion.msgType !== 'transfer' ? (
            <>
              {suggestion?.suggestionLabel && (
                <CcfBox
                  id={`agent_videocall_copilot_label_${suggestion?.suggestionLabel}`}
                  mb={2}
                >
                  <CcfTypography className={styles.suggestionLabel}>
                    {suggestion?.suggestionLabel}
                  </CcfTypography>
                </CcfBox>
              )}
              <CcfBox
                id={`agent_videocall_copilot_${suggestion.message}`}
                key={index}
                className={`${styles.suggestionCard} ${
                  suggestion?.msgType === 'suggestion' &&
                  styles.suggestionQuestionCard
                } ${
                  suggestion?.sentiment === 'Negative' &&
                  styles.negativeSentimentCard
                } ${
                  suggestion?.sentiment === 'Neutral' &&
                  styles.neutralSentimentCard
                } ${
                  suggestion?.sentiment === 'Positive' &&
                  styles.positiveSentimentCard
                } ${
                  suggestion?.isSelectedAsQuickReply &&
                  styles.selectedSuggestionCard
                }`}
                onClick={() => {
                  suggestionCardSelectHandler(suggestion);
                }}
              >
                {suggestion?.showIcon && (
                  <CcfBox>
                    {suggestion?.msgType === 'information' ||
                    suggestion?.msgType === 'suggestion' ? (
                      <CcfCopilotSuggestionIcon
                        className={styles.suggestionIcon}
                        fillColor={
                          suggestion?.msgType === 'suggestion' &&
                          !suggestion?.isSelectedAsQuickReply
                            ? '#518EB3'
                            : suggestion?.msgType === 'suggestion' &&
                              suggestion?.isSelectedAsQuickReply
                            ? '#ffffff'
                            : ''
                        }
                      />
                    ) : suggestion?.msgType === 'sentiment' &&
                      suggestion?.sentiment === 'Negative' ? (
                      <CcfSadSentimentIcon className={styles.suggestionIcon} />
                    ) : suggestion?.msgType === 'sentiment' &&
                      suggestion?.sentiment === 'Neutral' ? (
                      <CcfNeutralSentimentIcon
                        className={styles.suggestionIcon}
                      />
                    ) : suggestion?.msgType === 'sentiment' &&
                      suggestion?.sentiment === 'Positive' ? (
                      <CcfHeartIcon className={styles.suggestionIcon} />
                    ) : null}
                  </CcfBox>
                )}
                <CcfBox>
                  <CcfTypography className={styles.suggestionTxt}>
                    {suggestion.message.replace(
                      'liam.davis@gmail.com',
                      `${activeContact?.customer?.firstName}.${activeContact?.customer?.lastName}@gmail.com`
                    )}
                  </CcfTypography>
                </CcfBox>
              </CcfBox>
            </>
          ) : Object.keys(suggestion).length > 0 &&
            suggestion.msgType === 'flow' ? (
            <CcfBox
              id={`agent_videocall_newWorkflow_parent_container`}
              className={styles.workflowCard}
            >
              <CcfBox
                id="agent_videocall_newWorkflow_suggested_div"
                className={styles.workflowLabelBlock}
              >
                <CcfTypography className={styles.workflowLabel}>
                  New Workflow Suggested:
                </CcfTypography>
              </CcfBox>
              <CcfBox
                id={`agent_videocall_${suggestion.message}_div`}
                className={styles.workflowMsgBlock}
              >
                <CcfTypography className={styles.workflowMsg}>
                  {suggestion.message}
                </CcfTypography>
              </CcfBox>
              <CcfBox className={styles.workflowStateContainer}>
                {suggestion.buttonCaption === 'Start' ? (
                  <CcfButton
                    id={`agent_videocall_newWorkflow_${suggestion.buttonCaption}_button`}
                    primary
                    className={styles.startBtn}
                  >
                    <CcfTypography className={styles.startBtnText}>
                      {suggestion.buttonCaption}
                    </CcfTypography>
                  </CcfButton>
                ) : (
                  <CcfTypography
                    id={`agent_videocall_newWorkflow_${suggestion.buttonCaption}_text`}
                    className={styles.buttonCaptionTxt}
                  >
                    {suggestion.buttonCaption}
                  </CcfTypography>
                )}
              </CcfBox>
            </CcfBox>
          ) : (
            suggestion.msgType === 'transfer' && (
              <CcfBox
                id={`agent_videocall_transfer_preantContainer`}
                className={styles.workflowCard}
              >
                <CcfBox
                  id={`agent_videocall_transfer_${suggestion.message}_div`}
                  className={styles.workflowLabelBlock}
                >
                  <CcfTypography className={styles.transferLabel}>
                    {suggestion.message}
                  </CcfTypography>
                </CcfBox>

                <CcfBox className={styles.transferContainer}>
                  <CcfBadge
                    id={`agent_videocall_transferBadgeContainer_${suggestion.message}`}
                    overlap="circular"
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    variant="dot"
                    color="success"
                  >
                    <CcfTooltip
                      title={suggestion.message}
                      arrow
                      placement="right"
                    >
                      <Avatar
                        alt={suggestion.message}
                        src={suggestion.imgSrc}
                      ></Avatar>
                    </CcfTooltip>
                  </CcfBadge>
                  <CcfButton
                    id={`agent_videocall_transfer_${suggestion.buttonCaption}_button`}
                    primary
                    className={styles.startBtn}
                    onClick={() => initiateCallTransfer(suggestion.message)}
                  >
                    <CcfTypography className={styles.startBtnText}>
                      {suggestion.buttonCaption}
                    </CcfTypography>
                  </CcfButton>
                </CcfBox>
              </CcfBox>
            )
          );
        })}{' '}
      <CcfBox id={`agent_videocall_snackBar_container`}>
        <CcfSnackBar
          onClose={() => handleClose()}
          open={showCallTransferedToast}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <div id={`agent_videocall_snackBar_alret_container`}>
            <CcfAlert
              id={`agent_videocall_snackBar_callTransfer_alertContainer`}
              closeAlert={handleClose}
              severity="success"
            >
              {CallTransferredMessage}
            </CcfAlert>
          </div>
        </CcfSnackBar>
      </CcfBox>
    </>
  );
}

export default CcfCopilotVideoCallCard;
